import styled from 'styled-components';
import { CountDownContainer } from '../count-down';
import { SectionSummaryContainer } from '../section-summary/section-summary-preview.container';
import { getSize } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var paddingTopOfSectionSummary = 64;
export var marginBetweenItemsSectionSummary = 16;
var StyledSectionSummaryColumn = styled.div.withConfig({
  displayName: "section-summary-columncontainer__StyledSectionSummaryColumn",
  componentId: "sc-1ggy1ss-0"
})(["display:flex;flex-direction:column;gap:", ";height:100%;min-height:0;overflow:hidden;"], getSize('gap16'));
var StyledCountDownContainer = styled.div.withConfig({
  displayName: "section-summary-columncontainer__StyledCountDownContainer",
  componentId: "sc-1ggy1ss-1"
})(["flex-shrink:0;"]);
var StyledSectionSummary = styled.div.withConfig({
  displayName: "section-summary-columncontainer__StyledSectionSummary",
  componentId: "sc-1ggy1ss-2"
})(["display:flex;flex-direction:column;flex:1;min-height:0;overflow:hidden;"]);
export var SectionSummaryColumnContainer = function SectionSummaryColumnContainer(_ref) {
  var isModal = _ref.isModal,
      heightModal = _ref.heightModal,
      onCancelPin = _ref.onCancelPin,
      sectionLabels = _ref.sectionLabels,
      countDownLabels = _ref.countDownLabels,
      updateSelectedSection = _ref.updateSelectedSection,
      onSelectQuestion = _ref.onSelectQuestion;
  return /*#__PURE__*/_jsxs(StyledSectionSummaryColumn, {
    $height: heightModal,
    children: [!isModal && /*#__PURE__*/_jsx(StyledCountDownContainer, {
      children: /*#__PURE__*/_jsx(CountDownContainer, {
        labels: countDownLabels
      })
    }), /*#__PURE__*/_jsx(StyledSectionSummary, {
      children: /*#__PURE__*/_jsx(SectionSummaryContainer, {
        onCancelPin: onCancelPin,
        readonly: true,
        labels: sectionLabels,
        updateSelectedSection: updateSelectedSection,
        onSelectQuestion: onSelectQuestion
      })
    })]
  });
};